// Updated HomeProductos.js with the same Grid layout and styling
import React, { useContext, useState } from "react";
import fondo_productos from "../../images/fondo_productos_company.png";
import imagen_producto from "../../images/imagen_card_prueba.jpeg";
import { Grid, Button } from "@mui/material"; // Update your imports
import { useNavigate } from "react-router-dom";
import { returnFullURL } from '../../components';
import { ImagenesGlobal } from "../global/ImagenesGlobal";

const HomeProductos = ({ infoCompany, loadImageS, convertPrice = (() => { }) }) => {
	const navigate = useNavigate();
	const params = new URLSearchParams(window.location.search);
	const nit = params.get('search');

	const [currentSlide, setCurrentSlide] = useState(0);

	const products = infoCompany?.products ?? [];
	const brands = infoCompany?.brands ?? [];

	const API_URL = process.env.REACT_APP_API_URL;

	// 1) Dividir el array de brands en bloques (slides) de 4:
	const chunkSize = 4;
	const brandChunks = [];
	for (let i = 0; i < brands.length; i += chunkSize) {
		brandChunks.push(brands.slice(i, i + chunkSize));
	}

	// 2) Funciones para avanzar o retroceder entre páginas
	const handleNextBrands = () => {
		if (currentSlide < brandChunks.length - 1) {
			setCurrentSlide((prev) => prev + 1);
		}
	};

	const handlePrevBrands = () => {
		if (currentSlide > 0) {
			setCurrentSlide((prev) => prev - 1);
		}
	};

	// 3) Ancho total del contenedor interno
	const totalSlides = brandChunks.length;
	const containerWidth = `${totalSlides * 100}%`;

	// 4) Estilo para desplazar slides con transform
	const translateX = `translateX(-${currentSlide * (100 / totalSlides)}%)`;

	return (
		<div
			className="products-brands-company"
			style={{
				backgroundImage: `url(${fondo_productos})`,
				backgroundSize: "cover",
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center",
			}}>
			{/* Lista de productos */}
			<div className="products-company">
				<div className="content-sparkle">
					<h1 className="sparkle u-hover--sparkle" style={{ color: 'var(--theme-visit)' }}>
						Nuestros Productos
					</h1>
				</div>

				<div className="main-products-visite">
					{products.map((product, index) => (
						<div className="card-photo-product-v shadow-lvl6">
							<div className="photo-product" id="product-image-card">
								<ImagenesGlobal url={product?.img} type={'picture'} className="image-product-card" alt={product?.name} loadImageS={loadImageS} />
							</div>
							<div className="datos-product">
								<div className="code-precio">
									<span className="code-product">{product.code}</span>
									<span className="precio-product">{convertPrice(product.price, product?.currency)}</span>
								</div>
								<div className="description-product">
									<span className="des-product">{product.name}</span>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
			<div className="ver-mas-container">
				<Button
					variant="contained"
					size="large"
					onClick={() => {
						navigate('/company/products?search=' + nit);
					}}
					sx={{
						"backgroundColor": 'var(--theme-visit)',
						"borderRadius": "30px",
						"padding": { xs: "8px 20px", sm: "10px 24px", md: "12px 28px" },
						"fontSize": { xs: "0.9rem", sm: "1rem" },
						"fontWeight": 600,
						"textTransform": "uppercase",
						"letterSpacing": "0.5px",
						"boxShadow": "0 4px 8px rgba(0, 0, 0, 0.1)",
						"&:hover": {
							backgroundColor: 'var(--theme-visit)',
							transform: "translateY(-3px)",
							boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
						},
						"&:active": {
							transform: "translateY(-1px)",
							boxShadow: "0 3px 6px rgba(0, 0, 0, 0.1)",
						},
					}}>
					Ver Más Productos
				</Button>
			</div>
			{/* Carrusel de marcas */}
			<div className="brands-company">
				<div className="content-sparkle">
					<h1 className="sparkle u-hover--sparkle" style={{ color: 'var(--theme-visit)' }}>
						Nuestras Marcas
					</h1>
				</div>

				<div className="brands-carousel-outer">
					<button
						onClick={handlePrevBrands}
						className="arrow-button-brands left-arrow-brands"
						disabled={currentSlide === 0}
						style={{
							opacity: currentSlide === 0 ? 0.5 : 1,
							cursor: currentSlide === 0 ? "default" : "pointer",
						}}>
						&#10094;
					</button>

					<div className="brands-carousel-container">
						{/* Contenedor interno que se desplaza */}
						<div
							className="carousel-items-brands"
							style={{
								display: "flex",
								width: containerWidth,
								transform: translateX,
								transition: "transform 0.5s ease-in-out",
							}}>
							{brandChunks.map((chunk, chunkIndex) => (
								<div
									key={chunkIndex}
									className="brand-slide"
									style={{
										width: `${100 / totalSlides}%`,
										display: "flex",
										flexDirection: "row", // Explicitly set horizontal layout
										justifyContent: "space-around", // Better spacing between brands
										alignItems: "center", // Center items vertically
										padding: "0.5rem",
									}}>
									{/* Renderizar hasta 4 marcas en este chunk */}
									{chunk.map((brand, i) => (
										<div
											key={i}
											className="brand-item"
											style={{
												flex: "1 1 25%", // Each brand takes equal width with some flexibility
												maxWidth: "25%", // Limit maximum width
												padding: "0 0.5rem", // Add horizontal padding
												textAlign: "center",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}>

											{
												brand.img ? (
													<img
														src={returnFullURL(brand?.img ?? null, "picture")}
														alt={brand.name}
														style={{
															maxWidth: "100%",
															height: "100px",
															objectFit: "contain", // Maintain aspect ratio
														}}
													/>
												) : (
													<h3 >{brand.name}</h3>
												)
											}

										</div>
									))}
								</div>
							))}
						</div>
					</div>

					<button
						onClick={handleNextBrands}
						className="arrow-button-brands right-arrow-brands"
						disabled={currentSlide >= brandChunks.length - 1}
						style={{
							opacity: currentSlide >= brandChunks.length - 1 ? 0.5 : 1,
							cursor: currentSlide >= brandChunks.length - 1 ? "default" : "pointer",
						}}>
						&#10095;
					</button>
				</div>
			</div>
		</div >
	);
};

export default HomeProductos;
